import { Link } from "@inertiajs/react"

export const TurnUnusedGunsIntoCash = () => (
    <section className="w-full bg-[#ECECEC] px-[22px] py-[34px] text-center md:px-10 md:py-14">
        <h2 className="text-[24px] font-bold leading-[1.18] text-[#343434] md:text-[30px]">
            Turn Unused Guns Into Cash
        </h2>

        <p className="mx-auto mt-3 max-w-[31ch] text-left text-[16.5px] leading-[1.6] text-[#485460] md:max-w-[54ch] md:text-[17.5px]">
            Tell us what you have and get a cash offer, often within a few
            hours. Free shipping, no obligation.
        </p>

        <Link
            href="/sell-my-gun"
            className="seller-lift mx-auto mt-[22px] block max-w-[340px] rounded-full bg-[#800020] p-4 text-[15px] font-bold uppercase tracking-[.06em] text-white hover:bg-[#5E1214] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#343434]"
        >
            Sell a gun to us
        </Link>

        <p className="mt-3.5 text-[15px] text-[#606874]">
            Prefer an auction?{" "}
            <Link
                href="/gun-consignment"
                className="whitespace-nowrap text-[#343434] underline hover:text-[#800020]"
            >
                Consign a gun instead
            </Link>
            .
        </p>
    </section>
)
